module.exports = __webpack_public_path__ + "img/left_right_layout_3_old.8f4f66d7.jpg";